import axios from 'axios'

const initialState = window.STATE

export default {
    state: {
        announcement: initialState.stream?.announcement || null,
        preview: initialState.stream?.preview || null,
    },

    getters: {
        streamAnnouncement: state => state.announcement,
        streamPreview: state => state.preview,
        showStreamPreview: (state, getters, rootState) => {
            if (!state.preview || !state.preview.preview || !state.preview.show) return false
            if (rootState.accounts.user?.no_previews) return false
            if (rootState.core.streamPreviewHides[state.preview.id]) return false
            return true
        },
    },

    mutations: {
        setStream(state, data) {
            state.announcement = data?.announcement
            state.preview = data?.preview
        },
    },

    actions: {
        registerSocketHandlers({ commit }, { socket }) {
            socket.on('stream', data => commit('setStream', data))
        },

        async loadStream({ commit }) {
            const response = await axios.get('/api/stream/')
            commit('setStream', response.data)
        },

        initStreamPreview({ commit }) {
            if (initialState.user?.id !== 1) return

            window.previewStream = ({ title, description, img, live } = {}) => {
                commit('setStream', {
                    announcement: {
                        id: 0,
                        scheduled_title: live ? '' : (title || 'Stream title here'),
                        scheduled_description: live ? '' : (description || 'Stream description here'),
                        live_title: live ? (title || 'Live title here') : '',
                        live_description: live ? (description || 'Live description here') : '',
                        stream_url: 'https://www.twitch.tv/leahinmoonlight',
                        image_url: img || '',
                        stream_date: new Date(Date.now() + 1000 * 60 * 60 * 48).toISOString(),
                        is_live: !!live,
                    },
                    preview: null,
                })
            }
        },
    },
}
